class GameServerPublicInfo {
  readonly hostName: string | undefined
  readonly maxPlayers: number | undefined
  readonly gamePort: number | undefined
  readonly steamQueryPort: number | undefined
}

export default GameServerPublicInfo;